import Utils from "@/utils/utils"
import { InternalLink, RouteSettings } from "./type"
import { translate } from "@/plugins/i18n"

const adminLinks: (settings: RouteSettings) => InternalLink[] = (settings: RouteSettings) => {
  return [
    ...Utils.insertIf(settings.isAdmin, {
      route: { name: "WorkspacesList" },
      label: translate("AdminMenu.spaces"),
      icon: "navigate_view_grid_thumbnails_medium",
      "rbt-target": "workspaceList"
    }),
    ...Utils.insertIf(settings.isCustomerHosted && settings.isAdmin, {
      route: { name: "CoreLicenses" },
      label: translate("AdminMenu.coreLicenses"),
      icon: "vizengine_playout_configuration",
      "rbt-target": "core"
    }),
    ...Utils.insertIf(settings.isSaaS, {
      route: { name: "LandingPage" },
      label: translate("AdminMenu.launchPad"),
      icon: "action_run",
      "rbt-target": "launchPad"
    }),
    ...Utils.insertIf(settings.isAdmin, {
      route: { name: "OrganizationUsers", params: { organizationId: settings.selectedOrganizationId } },
      label: translate("AdminMenu.organizationUsers"),
      icon: "content_users",
      "rbt-target": "organizationUsers"
    }),
    ...Utils.insertIf(settings.isAdmin, {
      route: { name: "Organization", params: { organizationId: settings.selectedOrganizationId } },
      label: translate("AdminMenu.organization"),
      icon: "action_settings",
      "rbt-target": "organization"
    })
  ]
}

export default adminLinks
